let bindedBuffer = null

class ArrayBuffer {

	constructor(gl, data, size, element, name, type) {
		this.name = name;
		this.gl = gl;
		this._buffer = this.gl.createBuffer();
		this.type   = type || this.gl.FLOAT;
		this._element = element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER'
		this._target = this.gl[ element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER' ];
		this.update(data, size);
	}

	update(data, size) {
		this.data   = data;
		this.size   = size; 
		this.length = this.data.length;
		this.gl.bindBuffer( this._target, this._buffer);
		if (this.name == 'instanceMatrix') {
			this.gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.data, this.gl.STATIC_DRAW);
		}
		else {
			this.gl.bufferData( this._target, this.data, /*this.name == 'instanceMatrix' ? this.gl.DYNAMIC_DRAW :*/ this.gl.STATIC_DRAW);
		}
        this.gl.bindBuffer(this._target, null);
	}

	bind() {
		if (bindedBuffer != this) {
			bindedBuffer = this;
			this.gl.bindBuffer( this._target, this._buffer );
		}
	}

}

export default ArrayBuffer;